var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPolkadotjs = function SvgPolkadotjs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#polkadotjs_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.748.338A7.478 7.478 0 0 0 .3 7.787c0 .822.133 1.639.393 2.42.194.53.77.816 1.31.652.522-.2.8-.772.633-1.306a4.915 4.915 0 0 1-.29-1.898 5.373 5.373 0 1 1 5.697 5.524s-1.046.064-1.566.127a5.414 5.414 0 0 0-.57.114.069.069 0 0 1-.097 0 .068.068 0 0 1 0-.084l.161-.883.982-4.416a1.021 1.021 0 0 0-1.996-.427S2.62 18.42 2.62 18.518a.981.981 0 0 0 .727 1.197h.054a.98.98 0 0 0 1.196-.705l.006-.027a.252.252 0 0 1 0-.048c.029-.127.324-1.566.324-1.566a2.65 2.65 0 0 1 2.193-2.085c.225-.035 1.172-.099 1.172-.099A7.443 7.443 0 0 0 7.748.338Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6007A",
    d: "M8.2 17.512a1.241 1.241 0 0 0-1.468.962l-.003.02a1.236 1.236 0 0 0 .947 1.471h.034a1.216 1.216 0 0 0 1.469-.897l.004-.015v-.068a1.287 1.287 0 0 0-.982-1.473Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "polkadotjs_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3.338h14.699V20H.3z"
  })))));
};
export default SvgPolkadotjs;